import React from 'react';
import {
  string, number, func, arrayOf, shape, bool
} from 'prop-types';
import { Col, Row } from '@thd-olt-component-react/core-ui';
import {
  ProductPod,
  PodColumn,
  ProductRating,
  ProductBadge,
  ProductImage, PodSticker, PodSection,
  PodSpacer
} from '@thd-olt-component-react/product-pod';
import { Price } from '@thd-olt-component-react/price';
import { extend } from '@thd-nucleus/data-sources';
import { ProductHeader } from '@thd-olt-component-react/product-details';
import { CallToActionSection } from '../CTASection/CTASection';
import './custom-product-pod.scss';

export const CustomProductPod = ({
  index,
  itemId,
  storeId,
  onClick,
  products,
  productGroup,
  showCTA
}) => {
  return (
    <ProductPod
      itemId={itemId}
      storeId={storeId}
      analyticsData={{ parent: 'product-set', position: index + 1 }}
      render={() => (
        <div>
          <PodSticker position="top-left">
            <ProductBadge itemId={itemId} storeId={storeId} />
          </PodSticker>
          <PodSpacer padding={['TOP', 'BOTTOM']} />
          <PodSpacer padding={['BOTTOM']} />
          <Col nopadding fallback="3">
            <PodSpacer padding={['TOP', 'BOTTOM']} />
            <PodSpacer padding={['TOP']} />
            <ProductImage
              itemId={itemId}
              onClick={(event) => onClick(event, itemId)}
            />
          </Col>
          <Col nopadding fallback="7">
            <PodColumn>

              <PodSection columnAlign alignTop>
                <div className="custom-product-pod__price">
                  <Price
                    itemId={itemId}
                    large={false}
                    storeId={storeId}
                    displayEachUom={false}
                  />
                </div>
                <ProductRating itemId={itemId} />
                <div className="custom-product-pod__header">
                  <ProductHeader
                    brand="above"
                    itemId={itemId}
                    onClick={(event) => onClick(event, itemId)}
                  />
                </div>
              </PodSection>
            </PodColumn>
          </Col>
          <Row>
            <Col nopadding fallback="3" />
            <Col nopadding fallback="7">
              <CallToActionSection
                itemId={itemId}
                productGroup={productGroup}
                showCTA={showCTA}
                products={products}
              />
            </Col>
          </Row>
        </div>
      )}
    />
  );
};

CustomProductPod.propTypes = {
  index: number.isRequired,
  itemId: string.isRequired,
  storeId: string.isRequired,
  onClick: func,
  products: arrayOf(shape({})),
  productGroup: string,
  showCTA: bool.isRequired
};

CustomProductPod.defaultProps = {
  onClick: {},
  products: [],
  productGroup: ''
};

CustomProductPod.dataModel = extend(
  ProductPod,
  ProductImage,
  Price,
  ProductRating,
  ProductHeader,
  ProductBadge

);
